type ToastParams = {
  text: string;
  appearance?: 'success' | 'neutral' | 'error';
};

const readQueryParam = (key: string): string | null => {
  try {
    const url = new URL(window.location.href);
    const value = url.searchParams.get(key);
    return value && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
};

export const context = {
  username: readQueryParam('user') ?? null,
};

export const navigateTo = (url: string): void => {
  window.location.assign(url);
};

export const requestExpandedMode = (_event: Event, mode: string): void => {
  const target = mode === 'game' ? '/game' : '/';
  window.location.assign(target);
};

export const canRunAsUser = async (): Promise<boolean> => true;

export const showToast = ({ text, appearance }: ToastParams): void => {
  const prefix = appearance ? `[${appearance.toUpperCase()}] ` : '';
  console.info(`${prefix}${text}`);
};
